import { FunctionComponent, ReactElement } from 'react';
import SVG from 'react-inlinesvg';
import NextLink from 'next/link';
import ProgramList from 'components/Home/ProgramListSection/ProgramList';
import { IFormatsSectionCarouselProps } from 'typings/IFormatsSectionCarouselProps';
import { FormatsSectionStyle, FormatsSectionTitleStyle } from '../FormatAToZ.style';
import { ClickableTitleStyle } from '../../Home/Home.style';
import { ICONS } from '../../../constants/icons';

const FormatsSectionCarousel: FunctionComponent<IFormatsSectionCarouselProps> = ({
  title,
  formats,
  noOfShownItemsAbove,
  handleTitleClick
}): ReactElement => (
  <FormatsSectionStyle data-testid="formatsSectionCarousel">
    <NextLink href={`?genre=${title.toLowerCase()}`}>
      <ClickableTitleStyle data-testid="clickableTitle" onClick={() => handleTitleClick(title, true)}>
        <FormatsSectionTitleStyle>
          {title}
          <SVG src={ICONS.ARROW_SMALL_30} id="formatsSectionTitleArrow" />
        </FormatsSectionTitleStyle>
      </ClickableTitleStyle>
    </NextLink>
    <ProgramList programs={formats} sectionType="AToZFormats" noOfShownItemsAbove={noOfShownItemsAbove} />
  </FormatsSectionStyle>
);

export default FormatsSectionCarousel;
